(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2797],{

/***/ 62797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content071": function() { return /* binding */ Content071; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var features_translations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91929);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47696);
/* harmony import */ var shared_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87367);
/* harmony import */ var _Content071_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31643);
/* harmony import */ var _Content071_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Content071_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var Content071 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.headline) !== null && ref !== void 0 ? ref : "";
    var t = (0,features_translations__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$)().t;
    var ref1 = (0,shared_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useCollectedNewsRender */ .p$)({
        payload: payload,
        widgetNumber: "071"
    }), feed = ref1.feed, isCompleted = ref1.isCompleted, renderNext = ref1.renderNext, limit = ref1.limit, articleCategories = ref1.articleCategories, activeCategory = ref1.activeCategory;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content071_module_scss__WEBPACK_IMPORTED_MODULE_5___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Content071_module_scss__WEBPACK_IMPORTED_MODULE_5___default().inner),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Content071_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_Content071_module_scss__WEBPACK_IMPORTED_MODULE_5___default().top),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Heading3 */ .aC, {
                                        className: (_Content071_module_scss__WEBPACK_IMPORTED_MODULE_5___default().title),
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Heading6 */ .Cd, {
                                        className: (_Content071_module_scss__WEBPACK_IMPORTED_MODULE_5___default().category),
                                        color: "grey",
                                        children: activeCategory.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_Content071_module_scss__WEBPACK_IMPORTED_MODULE_5___default().blocks),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_Content071_module_scss__WEBPACK_IMPORTED_MODULE_5___default().feed),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .NewsItems */ .d2, {
                                            items: feed,
                                            className: (_Content071_module_scss__WEBPACK_IMPORTED_MODULE_5___default().items),
                                            limit: limit
                                        }),
                                        !isCompleted && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Action */ .aU, {
                                            onClick: renderNext,
                                            className: (_Content071_module_scss__WEBPACK_IMPORTED_MODULE_5___default().more),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_Content071_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Content071_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["loader-wrapper"])),
                                                    children: [
                                                        t("lazyRendering"),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                                                            className: (_Content071_module_scss__WEBPACK_IMPORTED_MODULE_5___default().icon),
                                                            name: "loader"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Content071_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["tags-list"]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .PopularTags */ .Dj, {
                            tags: articleCategories,
                            activeTag: activeCategory.slug
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content071);


/***/ }),

/***/ 31643:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content071_wrapper__A1zl_","more":"Content071_more__Wq65M","inner":"Content071_inner__0uQb3","top":"Content071_top__NytwT","content":"Content071_content__apr6K","title":"Content071_title__CKflE","blocks":"Content071_blocks__DpICI","tags-list":"Content071_tags-list__DspYP","loader":"Content071_loader__3KV3a","loader-wrapper":"Content071_loader-wrapper__M81YL","category":"Content071_category__S_wRl","feed":"Content071_feed__wogha"};

/***/ })

}]);